import React from 'react';

const Footer = () => {
  return (
    <footer className="footer footer-dark bg-primary fixed-bottom">
      <div className="container text-center">
        <span className="text-light">@2020 Built by Zack and the Boys.</span>
      </div>
    </footer>
  )
}

export default Footer;